import { OneWayInServiceProviderDto } from 'src/api/v2';

export function normalizeString(str) {
  return str
    .normalize('NFD')
    .replace(/(?![\u030a\u0338])[\u0300-\u036f]/g, '')
    .normalize('NFC');
}

export const filterWithNormalization = (haystack: string, needle: string) => {
  const normalizedHaystack = normalizeString(haystack?.toLowerCase() || '');
  const normalizedNeedle = normalizeString(needle.toLowerCase());
  return normalizedHaystack.includes(normalizedNeedle);
};

export const filterproviderMunicipality = (
  provider: Pick<OneWayInServiceProviderDto, 'municipalities'>,
  searchQuery: string,
) => {
  return provider.municipalities?.some((muni) => filterWithNormalization(muni, searchQuery)) ?? false;
};
export const filterServices = (
  provider: Pick<OneWayInServiceProviderDto, 'deliveryTypes'>,
  searchQuery: string,
) => {
  return provider.deliveryTypes?.some((service) => filterWithNormalization(service, searchQuery)) ?? false;
};

export const filterproviderCounty = (
  provider: Pick<OneWayInServiceProviderDto, 'county'>,
  searchQuery: string,
) => {
  return filterWithNormalization(provider.county || '', searchQuery);
};

export const filterproviderPortfolioIndustries = (
  provider: Pick<OneWayInServiceProviderDto, 'portfolioIndustries'>,
  searchQuery: string,
) => {
  return (
    provider.portfolioIndustries?.some((industry) => filterWithNormalization(industry.name, searchQuery)) ??
    false
  );
};
